// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 투자계획등록 화면 */

/* ── 탭 ── */
.ip-tabs {
  display: flex;
  gap: 0;
  border-bottom: 2px solid #d0d6e8;
  margin-bottom: 0;
}
.ip-tab {
  padding: 6px 18px;
  font-size: 13px;
  font-weight: 500;
  color: #666;
  border: 1px solid transparent;
  border-bottom: none;
  border-radius: 4px 4px 0 0;
  cursor: pointer;
  background: none;
  margin-bottom: -2px;
}
.ip-tab:hover { color: #4a90e2; }
.ip-tab.active {
  color: #2c3e6b;
  font-weight: 700;
  border-color: #d0d6e8;
  background: white;
  border-bottom: 2px solid white;
}

/* ── 조회조건 행 (탭 바로 아래) ── */
.ip-controls {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
  background: #f8f9fc;
  border: 1px solid #e0e4ef;
  border-top: none;
  border-radius: 0 0 4px 4px;
  padding: 7px 10px;
  margin-bottom: 10px;
}
.ip-ctrl-left {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
}
.ip-ctrl-left select {
  padding: 4px 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 12px;
  font-family: inherit;
  background: white;
}
.ip-ctrl-sep {
  width: 1px;
  height: 18px;
  background: #d0d6e8;
  margin: 0 6px;
}
.ip-ctrl-right {
  display: flex;
  align-items: center;
  gap: 14px;
  flex: 1 1;
  flex-wrap: wrap;
  font-size: 12px;
}
.ip-ctrl-item {
  display: flex;
  align-items: center;
  gap: 4px;
  color: #555;
  white-space: nowrap;
}
.ip-ctrl-item strong { color: #2c3e6b; font-weight: 700; }
.ip-ratio-ok    { color: #27ae60 !important; font-weight: 700; }
.ip-ratio-over  { color: #e74c3c !important; font-weight: 700; }
.ip-ratio-under { color: #e67e22 !important; font-weight: 700; }

/* ── 안내문 박스 ── */
.ip-info-box {
  background: #e8f4fd;
  border: 1px solid #bee3f8;
  border-left: 4px solid #4a90e2;
  border-radius: 5px;
  padding: 10px 14px;
  margin-bottom: 12px;
  font-size: 12px;
}
.ip-info-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: 600;
  color: #1a5276;
}
.ip-info-toggle {
  background: none;
  border: none;
  color: #4a90e2;
  font-size: 11px;
  cursor: pointer;
  padding: 0 4px;
  text-decoration: underline;
}
.ip-info-toggle:hover { color: #1565c0; }
.ip-info-body {
  margin-top: 8px;
  color: #1a3a5c;
  line-height: 1.65;
}
.ip-info-body p { margin: 2px 0; }
.ip-info-step {
  font-weight: 600;
  margin-top: 6px;
  margin-bottom: 2px;
  color: #1565c0;
}
.ip-info-note {
  color: #555;
  font-size: 11px;
  margin-left: 8px;
}

/* ── 그리드 공통 ── */
.ip-grid-wrap {
  overflow: auto;
}
.ip-grid {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
  table-layout: fixed;
}
.ip-grid th {
  position: sticky;
  top: 0;
  background: #f0f2f8;
  color: #2c3e6b;
  font-weight: 600;
  padding: 6px 8px;
  border-bottom: 2px solid #d0d6e8;
  border-right: 1px solid #dde2ef;
  text-align: right;
  z-index: 2;
  white-space: nowrap;
}
.ip-grid th:first-child { text-align: left; }
.ip-grid th.th-center { text-align: center; }
.ip-grid td {
  padding: 5px 8px;
  border-bottom: 1px solid #eef0f6;
  border-right: 1px solid #eef0f6;
  text-align: right;
  vertical-align: middle;
}
.ip-grid td:first-child { text-align: left; }
.ip-grid td.td-center { text-align: center; }

/* ── 섹터 행 (1단계) ── */
.ip-sec-row { background: #DCDCDC; }
.ip-sec-row td { font-weight: 700; }
.ip-sec-row:hover td { background: #D0D0D0 !important; }
.ip-sec-row.expanded td { background: #D8D8D8; }
.ip-sec-row.expanded:hover td { background: #CCCCCC !important; }

/* ── 섹터 편집 가능 셀 ── */
.ip-sec-edit { background: #fffacd; }
.ip-sec-edit:hover { background: #fff8b0 !important; }

/* ── 종목 헤더 행 ── */
.ip-stk-hdr td {
  background: #f0f2f8 !important;
  font-weight: 600;
  font-size: 11px;
  color: #555;
  padding: 4px 8px;
}

/* ── 종목 행 (2단계) ── */
.ip-stk-row { background: #fafafa; }
.ip-stk-row td { font-size: 0.9em; }
.ip-stk-row:hover td { background: #f0f4ff !important; }

/* 종목 들여쓰기 */
.ip-stk-name {
  padding-left: 40px !important;
  text-align: left !important;
}
/* └ 기호 */
.ip-stk-indent {
  color: #aaa;
  margin-right: 4px;
}

/* ── 종목 편집 가능 셀 ── */
.ip-stk-edit { background: #f0f8ff; }
.ip-stk-edit:hover { background: #e4f4ff !important; }

/* ── 수정된 셀 (dirty) ── */
.ip-dirty { background: #ffe4b5 !important; }
.ip-dirty:hover { background: #ffd98a !important; }

/* ── 종목 합계 행 ── */
.ip-stk-tot-row td {
  background: #f0f2f8 !important;
  font-weight: 600;
  font-size: 11px;
  color: #444;
}

/* ── 합계 행 (sticky) ── */
.ip-tot-row td {
  background: #4a5568 !important;
  color: #fff !important;
  font-weight: 700;
  position: sticky;
  bottom: 0;
  z-index: 2;
}

/* ── 인라인 편집 입력 ── */
.ip-edit-input {
  width: 100%;
  padding: 2px 4px;
  border: 1px solid #c8d0e0;
  border-radius: 3px;
  font-size: 12px;
  font-family: inherit;
  text-align: right;
  box-sizing: border-box;
  outline: none;
  background: transparent;
}
.ip-edit-input:focus {
  border-color: #4a90e2;
  background: white !important;
  box-shadow: 0 0 0 2px rgba(74,144,226,0.15);
}

/* ── 차이 색상 ── */
.ip-diff-pos { color: #1565c0; font-weight: 600; }
.ip-diff-neg { color: #c0392b; font-weight: 600; }

/* ── 삭제 버튼 ── */
.ip-del-btn {
  border: none;
  background: none;
  color: #bbb;
  font-size: 15px;
  cursor: pointer;
  padding: 0 2px;
  line-height: 1;
  transition: color 0.15s;
}
.ip-del-btn:hover { color: #e74c3c; }
.ip-del-btn:disabled { opacity: 0.4; cursor: not-allowed; }

/* ── 종목 추가 버튼 ── */
.ip-add-stk-btn {
  font-size: 11px;
  color: #4a90e2;
  background: none;
  border: 1px solid #4a90e2;
  border-radius: 3px;
  padding: 1px 6px;
  cursor: pointer;
  white-space: nowrap;
}
.ip-add-stk-btn:hover { background: #eef5ff; }
.ip-add-stk-btn:disabled { opacity: 0.5; cursor: not-allowed; }

/* ── 하단 버튼들 ── */
.ip-bottom-actions {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 8px;
}
.ip-add-sec-btn {
  font-size: 12px;
  color: #4a90e2;
  background: none;
  border: 1px solid #4a90e2;
  border-radius: 4px;
  padding: 4px 12px;
  cursor: pointer;
}
.ip-add-sec-btn:hover { background: #eef5ff; }
.ip-add-sec-btn:disabled { opacity: 0.5; cursor: not-allowed; }

.ip-admin-btn {
  font-size: 11px;
  color: #8B4513;
  background: #FFF8DC;
  border: 1px solid #D2B48C;
  border-radius: 4px;
  padding: 4px 12px;
  cursor: pointer;
  margin-left: auto;
}
.ip-admin-btn:hover { background: #FAEBD7; }
.ip-admin-btn:disabled { opacity: 0.5; cursor: not-allowed; }

/* ── 빈 상태 ── */
.ip-empty {
  text-align: center;
  color: #aaa;
  padding: 30px;
  font-size: 13px;
}

/* ── 팝업 ── */
.ip-popup-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.35);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}
.ip-popup {
  background: white;
  border-radius: 8px;
  padding: 20px 24px;
  min-width: 300px;
  box-shadow: 0 4px 20px rgba(0,0,0,0.2);
}
.ip-popup h3 {
  margin: 0 0 14px;
  font-size: 14px;
  color: #2c3e6b;
}
.ip-popup label {
  display: block;
  font-size: 12px;
  color: #555;
  margin-bottom: 4px;
}
.ip-popup select,
.ip-popup input[type="number"],
.ip-popup input[type="text"] {
  width: 100%;
  padding: 6px 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 12px;
  font-family: inherit;
  box-sizing: border-box;
  margin-bottom: 12px;
}
.ip-popup-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 4px;
}

/* ── 좌우 분할 레이아웃 ── */
.ip-split-container {
  display: flex;
  height: calc(100vh - 100px);
  overflow: hidden;
}
.ip-split-container.dragging {
  cursor: col-resize;
}
.ip-split-left {
  overflow: auto;
  flex-shrink: 0;
  padding-right: 4px;
}
.ip-split-resizer {
  width: 6px;
  background: #d0d6e8;
  cursor: col-resize;
  flex-shrink: 0;
  transition: background 0.15s;
}
.ip-split-resizer:hover { background: #4a90e2; }
.ip-split-resizer.dragging { background: #4a90e2; }
.ip-split-right {
  flex: 1 1;
  overflow-y: auto;
  overflow-x: hidden;
  min-width: 0;
  padding: 0 10px;
}

/* ── 차트 패널 ── */
.ip-chart-panel { padding: 4px 0; }
.ip-chart-toggle {
  display: flex;
  gap: 4px;
  margin-bottom: 10px;
  position: sticky;
  top: 0;
  background: white;
  padding: 4px 0 6px;
  z-index: 1;
  border-bottom: 1px solid #eee;
}
.ip-chart-btn {
  padding: 3px 14px;
  font-size: 12px;
  border: 1px solid #d0d6e8;
  border-radius: 3px;
  background: white;
  color: #555;
  cursor: pointer;
}
.ip-chart-btn.active {
  background: #4a90e2;
  color: white;
  border-color: #4a90e2;
  font-weight: 600;
}
.ip-chart-btn:hover:not(.active) { background: #f0f4ff; }
.ip-chart-title {
  text-align: center;
  font-size: 12px;
  font-weight: 600;
  color: #2c3e6b;
  margin: 8px 0 4px;
}
.ip-chart-empty {
  text-align: center;
  color: #aaa;
  padding: 40px 20px;
  font-size: 12px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/trade/InvestPlanPage.css"],"names":[],"mappings":"AAAA,cAAc;;AAEd,YAAY;AACZ;EACE,aAAa;EACb,MAAM;EACN,gCAAgC;EAChC,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,6BAA6B;EAC7B,mBAAmB;EACnB,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA,gBAAgB,cAAc,EAAE;AAChC;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,0BAA0B;EAC1B,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,iBAAiB;AACnB;AACA;EACE,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,SAAO;EACP,eAAe;EACf,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,mBAAmB;AACrB;AACA,uBAAuB,cAAc,EAAE,gBAAgB,EAAE;AACzD,kBAAkB,yBAAyB,EAAE,gBAAgB,EAAE;AAC/D,kBAAkB,yBAAyB,EAAE,gBAAgB,EAAE;AAC/D,kBAAkB,yBAAyB,EAAE,gBAAgB,EAAE;;AAE/D,iBAAiB;AACjB;EACE,mBAAmB;EACnB,yBAAyB;EACzB,8BAA8B;EAC9B,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,cAAc;EACd,0BAA0B;AAC5B;AACA,wBAAwB,cAAc,EAAE;AACxC;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;AACA,kBAAkB,aAAa,EAAE;AACjC;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,cAAc;AAChB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,MAAM;EACN,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,gCAAgC;EAChC,+BAA+B;EAC/B,iBAAiB;EACjB,UAAU;EACV,mBAAmB;AACrB;AACA,0BAA0B,gBAAgB,EAAE;AAC5C,wBAAwB,kBAAkB,EAAE;AAC5C;EACE,gBAAgB;EAChB,gCAAgC;EAChC,+BAA+B;EAC/B,iBAAiB;EACjB,sBAAsB;AACxB;AACA,0BAA0B,gBAAgB,EAAE;AAC5C,wBAAwB,kBAAkB,EAAE;;AAE5C,qBAAqB;AACrB,cAAc,mBAAmB,EAAE;AACnC,iBAAiB,gBAAgB,EAAE;AACnC,uBAAuB,8BAA8B,EAAE;AACvD,0BAA0B,mBAAmB,EAAE;AAC/C,gCAAgC,8BAA8B,EAAE;;AAEhE,qBAAqB;AACrB,eAAe,mBAAmB,EAAE;AACpC,qBAAqB,8BAA8B,EAAE;;AAErD,kBAAkB;AAClB;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB,cAAc,mBAAmB,EAAE;AACnC,iBAAiB,gBAAgB,EAAE;AACnC,uBAAuB,8BAA8B,EAAE;;AAEvD,YAAY;AACZ;EACE,6BAA6B;EAC7B,2BAA2B;AAC7B;AACA,SAAS;AACT;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA,qBAAqB;AACrB,eAAe,mBAAmB,EAAE;AACpC,qBAAqB,8BAA8B,EAAE;;AAErD,wBAAwB;AACxB,YAAY,8BAA8B,EAAE;AAC5C,kBAAkB,8BAA8B,EAAE;;AAElD,kBAAkB;AAClB;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,eAAe;EACf,WAAW;AACb;;AAEA,wBAAwB;AACxB;EACE,8BAA8B;EAC9B,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA,oBAAoB;AACpB;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,iBAAiB;EACjB,sBAAsB;EACtB,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,qBAAqB;EACrB,4BAA4B;EAC5B,2CAA2C;AAC7C;;AAEA,gBAAgB;AAChB,eAAe,cAAc,EAAE,gBAAgB,EAAE;AACjD,eAAe,cAAc,EAAE,gBAAgB,EAAE;;AAEjD,gBAAgB;AAChB;EACE,YAAY;EACZ,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,eAAe;EACf,cAAc;EACd,cAAc;EACd,uBAAuB;AACzB;AACA,oBAAoB,cAAc,EAAE;AACpC,uBAAuB,YAAY,EAAE,mBAAmB,EAAE;;AAE1D,mBAAmB;AACnB;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;AACA,wBAAwB,mBAAmB,EAAE;AAC7C,2BAA2B,YAAY,EAAE,mBAAmB,EAAE;;AAE9D,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;AACA,wBAAwB,mBAAmB,EAAE;AAC7C,2BAA2B,YAAY,EAAE,mBAAmB,EAAE;;AAE9D;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,iBAAiB;AACnB;AACA,sBAAsB,mBAAmB,EAAE;AAC3C,yBAAyB,YAAY,EAAE,mBAAmB,EAAE;;AAE5D,eAAe;AACf;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,eAAe;AACjB;;AAEA,aAAa;AACb;EACE,eAAe;EACf,QAAQ;EACR,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,sCAAsC;AACxC;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;AACA;EACE,cAAc;EACd,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;AACA;;;EAGE,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;EACR,eAAe;AACjB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,2BAA2B;EAC3B,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,UAAU;EACV,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,4BAA4B;AAC9B;AACA,0BAA0B,mBAAmB,EAAE;AAC/C,6BAA6B,mBAAmB,EAAE;AAClD;EACE,SAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,eAAe;AACjB;;AAEA,gBAAgB;AAChB,kBAAkB,cAAc,EAAE;AAClC;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,gBAAgB;EAChB,MAAM;EACN,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,6BAA6B;AAC/B;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;EACrB,gBAAgB;AAClB;AACA,mCAAmC,mBAAmB,EAAE;AACxD;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,eAAe;AACjB","sourcesContent":["/* 투자계획등록 화면 */\n\n/* ── 탭 ── */\n.ip-tabs {\n  display: flex;\n  gap: 0;\n  border-bottom: 2px solid #d0d6e8;\n  margin-bottom: 0;\n}\n.ip-tab {\n  padding: 6px 18px;\n  font-size: 13px;\n  font-weight: 500;\n  color: #666;\n  border: 1px solid transparent;\n  border-bottom: none;\n  border-radius: 4px 4px 0 0;\n  cursor: pointer;\n  background: none;\n  margin-bottom: -2px;\n}\n.ip-tab:hover { color: #4a90e2; }\n.ip-tab.active {\n  color: #2c3e6b;\n  font-weight: 700;\n  border-color: #d0d6e8;\n  background: white;\n  border-bottom: 2px solid white;\n}\n\n/* ── 조회조건 행 (탭 바로 아래) ── */\n.ip-controls {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  flex-wrap: wrap;\n  background: #f8f9fc;\n  border: 1px solid #e0e4ef;\n  border-top: none;\n  border-radius: 0 0 4px 4px;\n  padding: 7px 10px;\n  margin-bottom: 10px;\n}\n.ip-ctrl-left {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  flex-shrink: 0;\n}\n.ip-ctrl-left select {\n  padding: 4px 8px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 12px;\n  font-family: inherit;\n  background: white;\n}\n.ip-ctrl-sep {\n  width: 1px;\n  height: 18px;\n  background: #d0d6e8;\n  margin: 0 6px;\n}\n.ip-ctrl-right {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  flex: 1;\n  flex-wrap: wrap;\n  font-size: 12px;\n}\n.ip-ctrl-item {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  color: #555;\n  white-space: nowrap;\n}\n.ip-ctrl-item strong { color: #2c3e6b; font-weight: 700; }\n.ip-ratio-ok    { color: #27ae60 !important; font-weight: 700; }\n.ip-ratio-over  { color: #e74c3c !important; font-weight: 700; }\n.ip-ratio-under { color: #e67e22 !important; font-weight: 700; }\n\n/* ── 안내문 박스 ── */\n.ip-info-box {\n  background: #e8f4fd;\n  border: 1px solid #bee3f8;\n  border-left: 4px solid #4a90e2;\n  border-radius: 5px;\n  padding: 10px 14px;\n  margin-bottom: 12px;\n  font-size: 12px;\n}\n.ip-info-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-weight: 600;\n  color: #1a5276;\n}\n.ip-info-toggle {\n  background: none;\n  border: none;\n  color: #4a90e2;\n  font-size: 11px;\n  cursor: pointer;\n  padding: 0 4px;\n  text-decoration: underline;\n}\n.ip-info-toggle:hover { color: #1565c0; }\n.ip-info-body {\n  margin-top: 8px;\n  color: #1a3a5c;\n  line-height: 1.65;\n}\n.ip-info-body p { margin: 2px 0; }\n.ip-info-step {\n  font-weight: 600;\n  margin-top: 6px;\n  margin-bottom: 2px;\n  color: #1565c0;\n}\n.ip-info-note {\n  color: #555;\n  font-size: 11px;\n  margin-left: 8px;\n}\n\n/* ── 그리드 공통 ── */\n.ip-grid-wrap {\n  overflow: auto;\n}\n.ip-grid {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 12px;\n  table-layout: fixed;\n}\n.ip-grid th {\n  position: sticky;\n  top: 0;\n  background: #f0f2f8;\n  color: #2c3e6b;\n  font-weight: 600;\n  padding: 6px 8px;\n  border-bottom: 2px solid #d0d6e8;\n  border-right: 1px solid #dde2ef;\n  text-align: right;\n  z-index: 2;\n  white-space: nowrap;\n}\n.ip-grid th:first-child { text-align: left; }\n.ip-grid th.th-center { text-align: center; }\n.ip-grid td {\n  padding: 5px 8px;\n  border-bottom: 1px solid #eef0f6;\n  border-right: 1px solid #eef0f6;\n  text-align: right;\n  vertical-align: middle;\n}\n.ip-grid td:first-child { text-align: left; }\n.ip-grid td.td-center { text-align: center; }\n\n/* ── 섹터 행 (1단계) ── */\n.ip-sec-row { background: #DCDCDC; }\n.ip-sec-row td { font-weight: 700; }\n.ip-sec-row:hover td { background: #D0D0D0 !important; }\n.ip-sec-row.expanded td { background: #D8D8D8; }\n.ip-sec-row.expanded:hover td { background: #CCCCCC !important; }\n\n/* ── 섹터 편집 가능 셀 ── */\n.ip-sec-edit { background: #fffacd; }\n.ip-sec-edit:hover { background: #fff8b0 !important; }\n\n/* ── 종목 헤더 행 ── */\n.ip-stk-hdr td {\n  background: #f0f2f8 !important;\n  font-weight: 600;\n  font-size: 11px;\n  color: #555;\n  padding: 4px 8px;\n}\n\n/* ── 종목 행 (2단계) ── */\n.ip-stk-row { background: #fafafa; }\n.ip-stk-row td { font-size: 0.9em; }\n.ip-stk-row:hover td { background: #f0f4ff !important; }\n\n/* 종목 들여쓰기 */\n.ip-stk-name {\n  padding-left: 40px !important;\n  text-align: left !important;\n}\n/* └ 기호 */\n.ip-stk-indent {\n  color: #aaa;\n  margin-right: 4px;\n}\n\n/* ── 종목 편집 가능 셀 ── */\n.ip-stk-edit { background: #f0f8ff; }\n.ip-stk-edit:hover { background: #e4f4ff !important; }\n\n/* ── 수정된 셀 (dirty) ── */\n.ip-dirty { background: #ffe4b5 !important; }\n.ip-dirty:hover { background: #ffd98a !important; }\n\n/* ── 종목 합계 행 ── */\n.ip-stk-tot-row td {\n  background: #f0f2f8 !important;\n  font-weight: 600;\n  font-size: 11px;\n  color: #444;\n}\n\n/* ── 합계 행 (sticky) ── */\n.ip-tot-row td {\n  background: #4a5568 !important;\n  color: #fff !important;\n  font-weight: 700;\n  position: sticky;\n  bottom: 0;\n  z-index: 2;\n}\n\n/* ── 인라인 편집 입력 ── */\n.ip-edit-input {\n  width: 100%;\n  padding: 2px 4px;\n  border: 1px solid #c8d0e0;\n  border-radius: 3px;\n  font-size: 12px;\n  font-family: inherit;\n  text-align: right;\n  box-sizing: border-box;\n  outline: none;\n  background: transparent;\n}\n.ip-edit-input:focus {\n  border-color: #4a90e2;\n  background: white !important;\n  box-shadow: 0 0 0 2px rgba(74,144,226,0.15);\n}\n\n/* ── 차이 색상 ── */\n.ip-diff-pos { color: #1565c0; font-weight: 600; }\n.ip-diff-neg { color: #c0392b; font-weight: 600; }\n\n/* ── 삭제 버튼 ── */\n.ip-del-btn {\n  border: none;\n  background: none;\n  color: #bbb;\n  font-size: 15px;\n  cursor: pointer;\n  padding: 0 2px;\n  line-height: 1;\n  transition: color 0.15s;\n}\n.ip-del-btn:hover { color: #e74c3c; }\n.ip-del-btn:disabled { opacity: 0.4; cursor: not-allowed; }\n\n/* ── 종목 추가 버튼 ── */\n.ip-add-stk-btn {\n  font-size: 11px;\n  color: #4a90e2;\n  background: none;\n  border: 1px solid #4a90e2;\n  border-radius: 3px;\n  padding: 1px 6px;\n  cursor: pointer;\n  white-space: nowrap;\n}\n.ip-add-stk-btn:hover { background: #eef5ff; }\n.ip-add-stk-btn:disabled { opacity: 0.5; cursor: not-allowed; }\n\n/* ── 하단 버튼들 ── */\n.ip-bottom-actions {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-top: 8px;\n}\n.ip-add-sec-btn {\n  font-size: 12px;\n  color: #4a90e2;\n  background: none;\n  border: 1px solid #4a90e2;\n  border-radius: 4px;\n  padding: 4px 12px;\n  cursor: pointer;\n}\n.ip-add-sec-btn:hover { background: #eef5ff; }\n.ip-add-sec-btn:disabled { opacity: 0.5; cursor: not-allowed; }\n\n.ip-admin-btn {\n  font-size: 11px;\n  color: #8B4513;\n  background: #FFF8DC;\n  border: 1px solid #D2B48C;\n  border-radius: 4px;\n  padding: 4px 12px;\n  cursor: pointer;\n  margin-left: auto;\n}\n.ip-admin-btn:hover { background: #FAEBD7; }\n.ip-admin-btn:disabled { opacity: 0.5; cursor: not-allowed; }\n\n/* ── 빈 상태 ── */\n.ip-empty {\n  text-align: center;\n  color: #aaa;\n  padding: 30px;\n  font-size: 13px;\n}\n\n/* ── 팝업 ── */\n.ip-popup-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0,0,0,0.35);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n.ip-popup {\n  background: white;\n  border-radius: 8px;\n  padding: 20px 24px;\n  min-width: 300px;\n  box-shadow: 0 4px 20px rgba(0,0,0,0.2);\n}\n.ip-popup h3 {\n  margin: 0 0 14px;\n  font-size: 14px;\n  color: #2c3e6b;\n}\n.ip-popup label {\n  display: block;\n  font-size: 12px;\n  color: #555;\n  margin-bottom: 4px;\n}\n.ip-popup select,\n.ip-popup input[type=\"number\"],\n.ip-popup input[type=\"text\"] {\n  width: 100%;\n  padding: 6px 8px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 12px;\n  font-family: inherit;\n  box-sizing: border-box;\n  margin-bottom: 12px;\n}\n.ip-popup-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n  margin-top: 4px;\n}\n\n/* ── 좌우 분할 레이아웃 ── */\n.ip-split-container {\n  display: flex;\n  height: calc(100vh - 100px);\n  overflow: hidden;\n}\n.ip-split-container.dragging {\n  cursor: col-resize;\n}\n.ip-split-left {\n  overflow: auto;\n  flex-shrink: 0;\n  padding-right: 4px;\n}\n.ip-split-resizer {\n  width: 6px;\n  background: #d0d6e8;\n  cursor: col-resize;\n  flex-shrink: 0;\n  transition: background 0.15s;\n}\n.ip-split-resizer:hover { background: #4a90e2; }\n.ip-split-resizer.dragging { background: #4a90e2; }\n.ip-split-right {\n  flex: 1;\n  overflow-y: auto;\n  overflow-x: hidden;\n  min-width: 0;\n  padding: 0 10px;\n}\n\n/* ── 차트 패널 ── */\n.ip-chart-panel { padding: 4px 0; }\n.ip-chart-toggle {\n  display: flex;\n  gap: 4px;\n  margin-bottom: 10px;\n  position: sticky;\n  top: 0;\n  background: white;\n  padding: 4px 0 6px;\n  z-index: 1;\n  border-bottom: 1px solid #eee;\n}\n.ip-chart-btn {\n  padding: 3px 14px;\n  font-size: 12px;\n  border: 1px solid #d0d6e8;\n  border-radius: 3px;\n  background: white;\n  color: #555;\n  cursor: pointer;\n}\n.ip-chart-btn.active {\n  background: #4a90e2;\n  color: white;\n  border-color: #4a90e2;\n  font-weight: 600;\n}\n.ip-chart-btn:hover:not(.active) { background: #f0f4ff; }\n.ip-chart-title {\n  text-align: center;\n  font-size: 12px;\n  font-weight: 600;\n  color: #2c3e6b;\n  margin: 8px 0 4px;\n}\n.ip-chart-empty {\n  text-align: center;\n  color: #aaa;\n  padding: 40px 20px;\n  font-size: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
